import SessionCRUDActions from '../actions/SessionCRUDActions';
import { FORBIDDEN } from '@mm/constants/status-codes';
import commonHandler from './common-handler';

export const create = dispatch => error => {
  if (error.status === FORBIDDEN) {
    dispatch(SessionCRUDActions.clear('403'));

    return error;
  }
  commonHandler(dispatch)(error);
  throw error;
};
